import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Layout, Loader } from '@flexisaf/flexibull2';
import Theme from 'utils/theme';
import Disconnect from 'assets/images/plug.svg';
import { useHistory, useRouteMatch } from 'react-router';
import {
  getQueryVariable,
  setLocalAccessToken,
  setLocalRefreshToken,
  setLocalUser,
} from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { userLoginSuccess } from 'redux/users/actions';
import request from 'utils/request';
import orgConfig from 'utils/orgConfig';
import urls from 'utils/config';
import { CanFilter } from 'components/CanView';
import { menuItems } from 'routes';
import { selectOrgAliases } from 'redux/configurations/selectors';
import {
  getCanonicalOrgId,
  getPortalSlug,
  migrateAdminStorage,
  setAuthOrganisationId,
  setOrgRoutingKeys,
} from 'utils/portalSlug';

const handoffs = new Map();

const StyledDiv = styled.div`
  width: 100vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-top: 250px;
  & div {
    width: 45%;
    text-align: center;
  }
`;

/** Redeems a one-time app-switch code for this school's SAFApply session. */
const AppSso = () => {
  const [error, setError] = useState(false);
  const { params } = useRouteMatch();
  const history = useHistory();
  const portalSlug = getPortalSlug(params.orgName);
  const dispatch = useDispatch();
  const aliases = useSelector(selectOrgAliases);

  useEffect(() => {
    const code = getQueryVariable('code') || '';
    const canonicalOrgId = getCanonicalOrgId(params.orgName);
    if (!code || !canonicalOrgId) {
      setError(true);
      return undefined;
    }
    let pending = handoffs.get(code);
    if (!pending) {
      const url = `${urls.UMS_BASE_URL}/auth/products/${orgConfig.product}/organisations/${canonicalOrgId}/transfer`;
      pending = request({ method: 'post', url, data: { code } }).then((response) => {
        if (!response.success) {
          handoffs.delete(code);
        }
        return response;
      });
      handoffs.set(code, pending);
    }
    pending.then((response) => {
      if (!response.success) {
        setError(true);
        return;
      }
      dispatch(
        userLoginSuccess({
          ...response.raw.user,
          adminRoles: response.raw.user.roles,
        })
      );
      setLocalAccessToken(response.raw.access_token);
      setLocalRefreshToken(response.raw.refresh_token);
      setLocalUser(
        JSON.stringify({
          ...response.raw.user,
          adminRoles: response.raw.user.roles?.map((role) => ({
            adminLevel: role.admin_level,
            roles: role.role,
          })),
        })
      );
      setOrgRoutingKeys(canonicalOrgId, portalSlug);
      setAuthOrganisationId(canonicalOrgId);
      if (params.orgName && params.orgName !== portalSlug) {
        migrateAdminStorage(params.orgName, portalSlug);
      }
      const availableRoutes = CanFilter(menuItems(portalSlug, aliases));
      history.push(availableRoutes?.[0]?.navlink || `/${portalSlug}/user-profile`);
    });
    return undefined;
    // The code is read once from the address. Aliases may still be empty on this first paint.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout theme={{ Theme }}>
      <StyledDiv>
        {!error ? (
          <Loader color="grey" section size={65} />
        ) : (
          <div>
            <img src={Disconnect} alt="" />
            <h2>Could not open SAFApply</h2>
            <p>This sign-in link has expired. Sign in on this app to continue.</p>
            <Button onClick={() => history.push(`/${portalSlug}/`)}>Back to login</Button>
          </div>
        )}
      </StyledDiv>
    </Layout>
  );
};

export default AppSso;
